export type StarPrintAlignType = 'centre' | 'left' | 'right';

export default class CloudMarkupGenerator {
  private output = '';

  cut() {
    this.output += '[cut: feed; partial]\n';
    return this;
  }

  align(align: StarPrintAlignType) {
    this.output += `[align: ${align}]\n`;
    return this;
  }

  magnify(height: number, width: number) {
    this.output += `[magnify: width ${width}; height ${height}]\n`;
    return this;
  }

  barcode(type: 'code39', data: string, height: string, module: string, hri: boolean) {
    this.output += `[barcode: type ${type}; data ${data}; height ${height}; module ${module}; hri ${
      hri ? 'true' : 'false'
    }]\n`;
    return this;
  }

  qrCode(data: string, size = 3) {
    this.output += `[qrcode: data ${data}; size ${size}]\n`;

    return this;
  }

  text(text: string) {
    this.output += `${text}\n`;
    return this;
  }

  bold() {
    this.output += `[bold: on]\n`;
    return this;
  }

  toString() {
    return this.output;
  }

  exportAsBinary() {
    let binaryOutput = '';
    const ESC = '\x1b'; // Escape character
    const GS = '\x1d'; // Group Separator
    const defaultMagnify = `${ESC}\x69\x00\x00`;
    const leftAlign = `${ESC}\x1da\x00`;
    const defaultFontWidth = `${ESC}F`;
    // After each text we need to reset to the default, otherwise it will keep the styling to the next texts
    const resetToDefaultStyles = defaultMagnify + leftAlign + defaultFontWidth;

    // Command to enable UTF-8 mode
    const enableUTF8Command = ESC + GS + 't' + '\x80';
    binaryOutput += enableUTF8Command;

    // Convert markup to binary using escape sequences
    const lines = this.output.split('\n');
    for (const line of lines) {
      if (line.startsWith('[align:')) {
        const align = line.match(/\[align: (.*)\]/)?.[1];
        switch (align) {
          case 'left':
            binaryOutput += ESC + '\x1da\x00'; // Left alignment
            break;
          case 'centre':
            binaryOutput += ESC + '\x1da\x01'; // Center alignment
            break;
          case 'right':
            binaryOutput += ESC + '\x1da\x02'; // Right alignment
            break;
        }
      } else if (line.startsWith('[magnify:')) {
        // Star docs on Magnify (size of text) for reference: https://star-m.jp/products/s_print/sdk/StarDocumentMarkup/manual/en/tag-reference/magnify/index.html
        const width = line.match(/width (\d+)/)?.[1] ?? '1';
        const height = line.match(/height (\d+)/)?.[1] ?? '1';

        const heightCode = String.fromCharCode(parseInt(height));
        const widthCode = String.fromCharCode(parseInt(width));
        binaryOutput += `${ESC}\x69${heightCode}${widthCode}`;
      } else if (line.startsWith('[cut:')) {
        binaryOutput += ESC + 'd\x03'; // Cut feed escape sequence
      } else if (line.startsWith('[bold:')) {
        binaryOutput += ESC + 'E';
      } else if (line.startsWith('[qrcode:')) {
        //TODO: Implement QR Code generation
        // const dataMatch = line.match(/data (.*?);/);
        // const sizeMatch = line.match(/size (\d+)/);
        // const data = dataMatch?.[1] ?? ''; // Extract the QR code data
        // const size = sizeMatch ? parseInt(sizeMatch[1], 10) : 3; // Default to size 3 if not provided

        // // 1. Set QR Code Model (Model 2)
        // const setModelCommand = `${ESC}${GS}yS0\x32`;
        // binaryOutput += setModelCommand;

        // // 2. Set Error Correction Level (e.g., M level)
        // const setErrorCorrectionLevelCommand = `${ESC}${GS}yS1\x01`; // "1" for 15% correction (M level)
        // binaryOutput += setErrorCorrectionLevelCommand;

        // // 3. Set Cell Size (between 3 and 8)
        // const setSizeCommand = `${ESC}${GS}yS2${String.fromCharCode(size)}`;
        // binaryOutput += setSizeCommand;

        // // 4. Set QR Code Data
        // const length = data.length;
        // const nL = String.fromCharCode(length % 256); // Low byte of data length
        // const nH = String.fromCharCode(Math.floor(length / 256)); // High byte of data length
        // const setDataCommand = `${ESC}${GS}yD1\x00${nL}${nH}${data}`; // Note: No spaces added here
        // binaryOutput += setDataCommand;

        // // 5. Print QR Code
        // const printCommand = `${ESC}${GS}yP`;
        // binaryOutput += printCommand;

        binaryOutput += resetToDefaultStyles; // Reset styles
      } else if (line) {
        let text = line;

        if (line !== ' ') {
          // We want to trim spaces, but not empty lines
          text = text.trim();
        }
        binaryOutput += text + '\r\n';
        binaryOutput += resetToDefaultStyles;
      }
    }
    return binaryOutput;
  }
}
